import { WechatProfitSharingTypeEnum } from '@lighthouse/core'
import type { WeChatDeleteProfitSharingReceiverActionConfig } from '@lighthouse/shared'
import { useAtomData } from '@lighthouse/shared'
import { wechatMerchantCardLabel } from '@lighthouse/shared'
import React, { useMemo } from 'react'

import { otherPlatformListAtom } from '@/atoms/application/state'
import { useCurrentAppId, useCurrentEnvId } from '@/hooks/useApplication'
import { useDataSourceList } from '@/hooks/useDataSource'
import { useGetUserRecordOptions } from '@/hooks/usePage'

import * as CM from '../styles'
import { TakeVariableWithText, useTakeVariableWithText } from '../TakeVariableWithText'
import * as SC from '../WeChatAddProfitSharingReceiverCard/style'

type WeChatDeleteProfitSharingReceiverCardProps = {
    config: WeChatDeleteProfitSharingReceiverActionConfig
}

const WeChatDeleteProfitSharingReceiverCard: React.FC<WeChatDeleteProfitSharingReceiverCardProps> = ({ config }) => {
    const { type, account } = config

    const appId = useCurrentAppId()
    const envId = useCurrentEnvId()
    const dataSourceList = useDataSourceList(appId, envId)
    const otherPlatformList = useAtomData(otherPlatformListAtom)

    const userOption = useGetUserRecordOptions()

    const accountData = useTakeVariableWithText({ dataSourceList, value: account })

    const merchantLabel = useMemo(
        () => wechatMerchantCardLabel(otherPlatformList, config?.paymentAccountId),
        [otherPlatformList, config?.paymentAccountId]
    )
    if (!merchantLabel) {
        return null
    }

    return (
        <CM.CardItemContainer>
            <SC.TypeName>{merchantLabel}</SC.TypeName>
            <SC.Item>
                <SC.TypeName>分账接收方类型</SC.TypeName>
                <SC.Value>{type === WechatProfitSharingTypeEnum.MERCHANT_ID ? '商户' : '个人'}</SC.Value>
            </SC.Item>

            {accountData.data.objects.length > 0 && (
                <SC.Item>
                    <SC.TypeName>分账接收方账号</SC.TypeName>
                    <SC.Value>
                        <TakeVariableWithText
                            nodes={accountData.data.objects}
                            upstreamOptions={accountData.upstreamOptions}
                            userOption={userOption}
                        />
                    </SC.Value>
                </SC.Item>
            )}
        </CM.CardItemContainer>
    )
}

export default WeChatDeleteProfitSharingReceiverCard
